import * as types from './types';
import * as _ from 'lodash';

import {
  EditDailyDepositSalesFieldEnum as SalesFields,
  EditDailyDepositAccrualsFieldEnum as AccrualsFields,
  EditDailyDepositInfoFieldEnum as InfoFields,
  EditDailyDepositFieldEnum as Fields,
} from 'Common/FieldEnum';
import { formatToCashAllowNegative } from 'Common/FormHelper';
import { defaultDateFormat } from 'Common/GeneralHelper';

const INITIAL_STATE = {
  initialValues: [],
  fetchError: '',
  fetching: true,
  loading: false,
  fetchingStack: [],
  sites: [],
  newSiteId: null,
  newServingDT: null,
  newIsSupper: null,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.EDIT_DAILY_DEPOSIT_GET_DATA:
      var formattedData = _.cloneDeep(payload);
      if (formattedData) {
        if (formattedData[Fields.Sales]) {
          const salesFields = [
            SalesFields.BSales,
            SalesFields.BSalesDetail1,
            SalesFields.BSalesDetail2,
            SalesFields.LSales,
            SalesFields.LSalesDetail1,
            SalesFields.LSalesDetail2,
            SalesFields.OSales,
            SalesFields.OSalesDetail1,
            SalesFields.OSalesDetail2,
            SalesFields.SSales,
            SalesFields.SSalesDetail1,
            SalesFields.SSalesDetail2,
          ];

          formattedData[Fields.Sales].forEach(row => {
            salesFields.forEach(field => {
              if (_.has(row, field)) {
                row[field] = formatToCashAllowNegative(row[field]);
              }
            });
          });
        }
        if (formattedData[Fields.Accruals]) {
          const accrualsFields = [
            AccrualsFields.Accruals,
            AccrualsFields.ChargesMade,
            AccrualsFields.ChargesPaid,
            AccrualsFields.ExtraCredit,
            AccrualsFields.PrepayAmount,
            AccrualsFields.PrepayUsed,
          ];

          formattedData[Fields.Accruals].forEach(row => {
            accrualsFields.forEach(field => {
              if (_.has(row, field)) {
                row[field] = formatToCashAllowNegative(row[field]);
              }
            });
          });
        }
        if (formattedData[Fields.Info]) {
          const infoFields = [
            InfoFields.Misc1Amount,
            InfoFields.Misc2Amount,
            InfoFields.AttendanceFactor,
            InfoFields.DepositAmount,
            InfoFields.SiteDeposit,
            InfoFields.LabourHours,
          ];

          infoFields.forEach(field => {
            if (_.has(formattedData[Fields.Info], field)) {
              formattedData[Fields.Info][field] = formatToCashAllowNegative(
                formattedData[Fields.Info][field]
              );
            }
          });

          formattedData[Fields.Info][
            InfoFields.ClosingDate
          ] = defaultDateFormat(
            formattedData[Fields.Info][InfoFields.ClosingDate]
          );
        }
      }
      return {
        ...state,
        initialValues: formattedData,
      };
    case types.EDIT_DAILY_DEPOSIT_NEW_ID:
      return {
        ...state,
        newSiteId: payload.Data.SiteId,
        newServingDT: payload.Data.ServingDT,
        newIsSupper: payload.Data.IsSupper,
      };
    case types.EDIT_DAILY_DEPOSIT_FETCH_ERROR:
      return { ...state, fetchError: payload };
    case types.EDIT_DAILY_DEPOSIT_LOADING:
      return { ...state, loading: payload };
    case types.EDIT_DAILY_DEPOSIT_GET_SITES:
      return { ...state, sites: payload };
    case types.EDIT_DAILY_DEPOSIT_FETCHING:
      let stack = state.fetchingStack;

      if (payload) {
        stack.push(true);
      } else {
        stack.pop();
      }

      return {
        ...state,
        fetching: stack.length > 0,
        fetchingStack: stack,
      };

    case types.EDIT_DAILY_DEPOSIT_CLEAR_STATE:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/state/editdailydeposit/reducer.js